/** CTA types that use floating progress + result cards instead of prose + thinking steps. */
export const STORY_BIBLE_CTA_TYPES = [
  "generate_chapter",
  "rewrite_chapter",
  "generate_character",
  "generate_worldbuilding",
  "generate_synopsis",
  "rewrite_synopsis",
  "generate_outline",
  "rewrite_outline",
  "generate_trait",
  "rewrite_trait",
  "generate_worldbuilding_trait",
  "rewrite_worldbuilding_trait",
  "generate_cast",
] as const;

export type StoryBibleCtaType = (typeof STORY_BIBLE_CTA_TYPES)[number];

export function isStoryBibleCtaType(type: string | undefined): type is StoryBibleCtaType {
  return type != null && (STORY_BIBLE_CTA_TYPES as readonly string[]).includes(type);
}
